import clientStorage from '@Common/Core/ClientStorage';
import constants from '@Common/Core/Constant';
import { properties } from '@Common/Core/Properties';
import urlHelper from '@Common/Helpers/UrlHelper';
import { DashboardCookieSettings, DocumentDescriptor } from '@InstanceFactory';
import documentUtils from '../Helpers/DocumentUtils';
import { IDocumentIdentifier } from '@Common/Entities/BaseEntities';

export interface IProject {
    id: string;
    name: string;
}

export default class AppHelper {
    public static projectId: string = null;
    public static clipboard: { [id: string]: any } = {};
    public static formulaClipboard = null;
    public static projects: IProject[];

    public static showAnchors = false;
    public static snapToGrid = true;
    public static blackCanvas = false;

    public static getProject(projectId: string): IProject {
        return _.find(AppHelper.projects, project => project.id === projectId);
    }

    public static getProjectNameById(projectId: Guid): string {
        const project = AppHelper.getProject(projectId);
        return project ? project.name : '';
    }

    public static getActiveProject(): IProject {
        return AppHelper.getProject(AppHelper.projectId);
    }

    public static setActiveProjectId(projectId: string): void {
        AppHelper.projectId = projectId;
    }

    public static getUniqueDocumentIdentificatorId(docIdentificator: IDocumentIdentifier): string {
        return AppHelper.getUniqueDocumentId(docIdentificator.documentDescriptor, docIdentificator.projectId);
    }

    public static getUniqueDocumentId(doc: DocumentDescriptor, projectId: string = AppHelper.projectId): string {
        return (projectId ? projectId + ':' : '') + AppHelper.getDocumentId(doc);
    }

    public static cookieStudioSettings(): DashboardCookieSettings {
        return clientStorage.getGlobalSettings();
    }

    private static getDocumentId(doc: DocumentDescriptor): string {
        if (doc.id && doc.id !== constants.guidEmpty) {
            return doc.id;
        }
        if (doc.category) {
            return doc.category;
        }
        return documentUtils.getReferencedClassName(doc);
    }

    public static isDebugMode(): boolean {
        return properties.isDebug || altosoft.model.isDebug || urlHelper.isDebug();
    }
}
